import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=c8f80116&scoped=true&"
import script from "./Statistics.vue?vue&type=script&lang=ts&"
export * from "./Statistics.vue?vue&type=script&lang=ts&"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=c8f80116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f80116",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/Romppu/source/repos/poker-serverless/pokerapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VList,VListTile,VListTileContent})
